<script setup>
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';
import { useHeaderPins, CASAS } from 'dashboard/composables/useHeaderPins';

const props = defineProps({
  modulo: { type: String, required: true },
});

const emit = defineEmits(['done']);

const { t } = useI18n();
const { casaDe, fixar, devolver } = useHeaderPins();

const noTopo = () => casaDe(props.modulo) === CASAS.TOPO;
const label = computed(() =>
  t(
    noTopo()
      ? 'CONVERSATION.HEADER.PINS.BACK_TO_RAIL'
      : 'CONVERSATION.HEADER.PINS.PIN_TO_TOP'
  )
);

const alternar = () => {
  if (noTopo()) devolver(props.modulo);
  else fixar(props.modulo);
  emit('done');
};
</script>

<!-- Discreto de proposito (Lucas, 01/09): e um ajuste de layout que aparece em
     todo popover, nao a acao principal de nenhum deles. -->
<template>
  <button
    v-tooltip.bottom="label"
    type="button"
    :data-testid="`pin-action-${modulo}`"
    :aria-label="label"
    :aria-pressed="noTopo()"
    class="inline-flex size-8 shrink-0 items-center justify-center rounded-lg text-n-slate-11 transition-colors hover:bg-n-alpha-2 hover:text-n-slate-12 focus-visible:outline focus-visible:outline-2 focus-visible:outline-n-brand"
    @click.stop="alternar"
  >
    <span
      class="size-4"
      :class="noTopo() ? 'i-ph-push-pin-slash' : 'i-ph-push-pin'"
      aria-hidden="true"
    />
  </button>
</template>
